import React, { useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import {
    Box,
    LinearProgress,
    Snackbar,
    Button,
    IconButton,
    Typography,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import QRCode from "./personalWAComponent/QRCode";
import WADashboard from "./personalWAComponent/WADashboard";
import { Close } from "@mui/icons-material";
import Cookies from "js-cookie";
import { getSocket } from "../socket";
import axios from "axios";

const PersonalWhatsapp = () => {
    const [qrCode, setQrCode] = useState(null);
    const [connected, setConnected] = useState(false);
    const [backdropOpen, setBackdropOpen] = useState(true);
    const [waiting, setWaiting] = useState(false);
    const [open, setOpen] = useState(false);
    // const [userId, setUserId] = useState(Cookies.get("userId"));
    const [connectedPhone, setConnectedPhone] = useState(null);
    const [connectionStatus, setConnectionStatus] = useState(false);
    const [refreshBtnDisabled, setRefreshBtnDisabled] = useState(false);
    const [msg, setMsg] = useState("");
    const socketRef = useRef(null);
    const userId = Cookies.get("userId");

    // const socket =  getSocket(userId);

    const refreshQrCode = () => {
        const socket = socketRef.current;
        if (!socket) return;
        setRefreshBtnDisabled(true);

        socket.emit("Start-connection", { userId });

        setTimeout(() => setRefreshBtnDisabled(false), 5000);
    };

    // for backend connection and managing sessions
    useEffect(() => {
        const timeoutId = setTimeout(() => setBackdropOpen(false), 3000);
        const session = localStorage.getItem("session");
        if (session == "active") {
            setConnected(true);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    useEffect(() => {
        const initSocket = async () => {
            const socket = await getSocket(userId);
            if (!socket) return;

            socketRef.current = socket;

            const fetchStatus = async () => {
                try {
                    console.log("userId ", userId);
                    const res = await axios.get(
                        `http://api.virtualprachar.com/api/whatsapp-user/getstatus?user_id=${userId}`
                    );

                    console.log("fetchStatus worked", res.data);
                    if (res.data.data.status == "DISCONNECTED") {
                        resetData();
                    }
                } catch (e) {
                    console.log("Error : ", e);
                }
            };

            fetchStatus();

            // All your event listeners go here

            socket.on("contacts-sent", ({ userId: currentUserId, data }) => {
                console.log(currentUserId);
                console.log("dataaaaaaaaaa", data);
            });

            // === Session Management ===
            socket.on("qr", ({ userId: eventUserId, qrCodeDataUrl }) => {
                console.log("Socket id: ", socket.id);

                if (eventUserId === userId) setQrCode(qrCodeDataUrl);
            });

            socket.on("session-active", () => {
                setConnected(true);
                setQrCode(null);
            });

            socket.on("session-ended", () => {
                setConnected(false);
            });

            socket.on("sessionReplaced", ({ userId: eventUserId }) => {
                if (eventUserId === userId) resetData();
            });

            socket.on("logout", ({ userId: eventUserId }) => {
                if (eventUserId === userId) resetData();
            });

            socket.on("logoutSuccess", ({ userId: eventUserId }) => {
                if (eventUserId === userId) resetData();
            });

            // === Connection Success ===
            socket.on(
                "connection-success",
                ({ userId: eventUserId, phoneNumber, connection }) => {
                    console.log(eventUserId);
                    console.log("Socket id: ", socket.id);
                    if (eventUserId === userId) {
                        setConnected(true);
                        setConnectedPhone(phoneNumber);
                        setConnectionStatus(connection);
                        localStorage.setItem("session", "active");
                        localStorage.setItem(
                            "userPhone",
                            JSON.stringify(phoneNumber.slice(0, 12))
                        );
                        setQrCode(null);
                    }
                }
            );

            socket.on(
                "already-connected",
                ({ userId: eventUserId, phoneNumber }) => {
                    if (eventUserId === userId) {
                        setConnected(true);
                        setConnectedPhone(phoneNumber);
                        localStorage.setItem("session", "active");
                        localStorage.setItem(
                            "userPhone",
                            JSON.stringify(phoneNumber.slice(0, 12))
                        );
                    }
                }
            );

            // === Optional: Handle Disconnects & Reconnects ===
            socket.on("disconnect", (reason) => {
                console.warn("Socket disconnected:", reason);
                setConnected(false);
                setConnectionStatus("disconnected");
            });

            socket.on("reconnect_attempt", (attempt) => {
                console.log(`Reconnecting... (attempt ${attempt})`);
                setConnectionStatus("reconnecting");
            });

            socket.on("reconnect", () => {
                console.log("Reconnected to server");
                setConnectionStatus("connected");
                socket.emit("connection-status", { userId }); // re-check session state
            });

            socket.on("reconnect_failed", () => {
                console.error("Reconnection failed");
                setConnectionStatus("failed");
            });
            // Handle disconnection
        };

        initSocket();

        return () => {
            const socket = socketRef.current;
            if (socket) {
                socket.disconnect(); // or just remove listeners
                console.log("Socket is removed ");
            }
        };
    }, []); // rerun if userId changes

    // useEffect(() => {
    //     // const socket = getSocket(userId);

    //     // === Emit initial connection status check ===
    //     // socket.emit("connection-status", { userId });
    //     if (!socket) {
    //         console.log("Not defined");
    //     }

    //     const fetchStatus = async () => {
    //         try {
    //             console.log("userId ", userId);
    //             const res = await axios.get(
    //                 `http://api.virtualprachar.com/api/whatsapp-user/getstatus?user_id=${userId}`
    //             );

    //             console.log("fetchStatus worked", res.data);
    //             if (res.data.data.status == "DISCONNECTED") {
    //                 resetData();
    //             }
    //         } catch (e) {
    //             console.log("Error : ", e);
    //         }
    //     };

    //     fetchStatus();

    //     socket.on("contacts-sent", ({ userId: currentUserId, data }) => {
    //         console.log(currentUserId);
    //         console.log("dataaaaaaaaaa", data);
    //     });

    //     // === Session Management ===
    //     socket.on("qr", ({ userId: eventUserId, qrCodeDataUrl }) => {
    //         console.log("Socket id: ", socket.id);

    //         if (eventUserId === userId) setQrCode(qrCodeDataUrl);
    //     });

    //     socket.on("session-active", () => {
    //         setConnected(true);
    //         setQrCode(null);
    //     });

    //     socket.on("session-ended", () => {
    //         setConnected(false);
    //     });

    //     socket.on("sessionReplaced", ({ userId: eventUserId }) => {
    //         if (eventUserId === userId) resetData();
    //     });

    //     socket.on("logout", ({ userId: eventUserId }) => {
    //         if (eventUserId === userId) resetData();
    //     });

    //     socket.on("logoutSuccess", ({ userId: eventUserId }) => {
    //         if (eventUserId === userId) resetData();
    //     });

    //     // === Connection Success ===
    //     socket.on(
    //         "connection-success",
    //         ({ userId: eventUserId, phoneNumber, connection }) => {
    //             console.log(eventUserId);
    //             console.log("Socket id: ", socket.id);
    //             if (eventUserId === userId) {
    //                 setConnected(true);
    //                 setConnectedPhone(phoneNumber);
    //                 setConnectionStatus(connection);
    //                 localStorage.setItem("session", "active");
    //                 localStorage.setItem(
    //                     "userPhone",
    //                     JSON.stringify(phoneNumber.slice(0, 12))
    //                 );
    //                 setQrCode(null);
    //             }
    //         }
    //     );

    //     socket.on(
    //         "already-connected",
    //         ({ userId: eventUserId, phoneNumber }) => {
    //             if (eventUserId === userId) {
    //                 setConnected(true);
    //                 setConnectedPhone(phoneNumber);
    //                 localStorage.setItem("session", "active");
    //                 localStorage.setItem(
    //                     "userPhone",
    //                     JSON.stringify(phoneNumber.slice(0, 12))
    //                 );
    //             }
    //         }
    //     );

    //     // === Optional: Handle Disconnects & Reconnects ===
    //     socket.on("disconnect", (reason) => {
    //         console.warn("Socket disconnected:", reason);
    //         setConnected(false);
    //         setConnectionStatus("disconnected");
    //     });

    //     socket.on("reconnect_attempt", (attempt) => {
    //         console.log(`Reconnecting... (attempt ${attempt})`);
    //         setConnectionStatus("reconnecting");
    //     });

    //     socket.on("reconnect", () => {
    //         console.log("Reconnected to server");
    //         setConnectionStatus("connected");
    //         socket.emit("connection-status", { userId }); // re-check session state
    //     });

    //     socket.on("reconnect_failed", () => {
    //         console.error("Reconnection failed");
    //         setConnectionStatus("failed");
    //     });

    //     // === Cleanup ===
    //     return () => {
    //         socket.off("qr");
    //         socket.off("session-active");
    //         socket.off("session-ended");
    //         socket.off("connection-success");
    //         socket.off("already-connected");
    //         socket.off("logout");
    //         socket.off("logoutSuccess");
    //         socket.off("sessionReplaced");

    //         socket.off("disconnect");
    //         socket.off("reconnect_attempt");
    //         socket.off("reconnect");
    //         socket.off("reconnect_failed");
    //     };
    // }, []);

    const resetData = () => {
        setConnected(false);
        setBackdropOpen(true);
        localStorage.removeItem("session");
        localStorage.removeItem("userPhone");
        setTimeout(() => setBackdropOpen(false), 1000);

        // alert("Login again may be session replaced");
        console.log("Login again may be session replaced");
    };

    const handleStartConnection = () => {
        if (!userId) {
            alert("No user ID found!");
            return;
        }

        setConnectionStatus(true);
        // socketRef.current.emit("start-connection", { userId });
    };

    // Handling logout
    const whatsAppLogout = () => {
        socketRef.current.emit("logout", { userId });
        setConnected(false);
        localStorage.removeItem("session");
    };

    const handleClose = () => {
        setOpen(false);
        setMsg("");
    };

    const action = (
        <React.Fragment>
            {/* <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
            </Button> */}
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <Close fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    // const logout = () => {
    //     console.log("logout function called");
    //     setConnected(false);
    //     setMsg("Logged Out!");
    //     setWaiting(false);
    //     setOpen(true);
    //     localStorage.removeItem("session");
    // };

    return (
        <Box
            sx={{
                marginTop: "1rem",
                "@media(max-width:768px)": {
                    marginTop: "1rem",
                    marginLeft: -10,
                    marginRight: -2,
                },
            }}
        >
            {/* <input type="text" value={userId} onChange={handleChange} /> */}

            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                autoHideDuration={10000}
                onClose={handleClose}
                message={msg}
                action={action}
            />
            {/* {waiting && <LinearProgress />} */}
            {backdropOpen ? (
                <Backdrop
                    sx={(theme) => ({
                        color: "#fff",
                        zIndex: theme.zIndex.drawer + 1,
                    })}
                    open={backdropOpen}
                    onClick={handleClose}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            ) : (
                <>
                    {connected && (
                        <>
                            <WADashboard
                                userId={userId}
                                whatsAppLogout={whatsAppLogout}
                            />
                        </>
                    )}
                    {!connected && (
                        <>
                            <QRCode
                                qrCode={qrCode}
                                startConnection={handleStartConnection}
                            />
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "1rem",
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={refreshQrCode}
                                    // sx={{ marginRight: "auto", marginLeft: "auto" }}
                                >
                                    Refresh
                                </Button>
                            </Box>
                        </>
                    )}
                </>
            )}
        </Box>
    );
};

export default PersonalWhatsapp;
